import { useMutation } from '@tanstack/react-query';
import { pincodeLookupService, PincodePostOffice } from '../services/pincodeLookup';

export const usePincodeLookup = () => {
  return useMutation<PincodePostOffice | null, Error, string>({
    mutationFn: (pincode: string) => pincodeLookupService.lookupPincode(pincode),
  });
};
